// «طلبات أولياء الأمور» (leave + visit requests from the parent app) — shared by the two pages
// (views/students/requests/requests.vue), the settings section in app-settings.vue and the sidebar badges.
//   reqCounts            reactive {leave, visit}: pending counts, polled every 60 s from /user/students/requests/counts
//                        while the dashboard is open (only for a user with one of the two permissions)
//   startRequestCounts(vm)  VerticalNavMenu.vue: starts the poll once; a rise → a toast with the bell sound
//   refreshRequestCounts()  the pages call it after an action so the badges follow at once
//   reqPost(path, body)  POST /user/students/requests/<path> as JSON ({actions:{call:true}} stays an object)
//   pick(r, key)         a reply field at the top or inside `response`
// Contract: /Users/hazem/work/Builds/specs/PARENT_REQUESTS_SPEC.md (A+B).
import Vue from 'vue'

export const REQ_PERS = { leave: 'students|requests|leave', visit: 'students|requests|visit' }
export const REQ_PAGES = { leave: '/_students/leave-requests', visit: '/_students/visit-requests' }

// Option `parent_requests` when the school never saved it (same as the server's defaults)
export const REQ_DEFAULTS = {
  leave: {
    enabled: true, from: '', to: '', days_ahead: 3,
    approve_defaults: { call: true, leave_record: false, teachers: false },
    auto_note_approve: '', auto_note_reject: '',
  },
  visit: {
    enabled: true, min_days: 0, max_days: 60, days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday'],
    from: '07:00', to: '12:00', auto_note_approve: '', auto_note_reject: '',
  },
}

export const WEEKDAYS = [
  { key: 'Sunday', title: 'الأحد' },
  { key: 'Monday', title: 'الإثنين' },
  { key: 'Tuesday', title: 'الثلاثاء' },
  { key: 'Wednesday', title: 'الأربعاء' },
  { key: 'Thursday', title: 'الخميس' },
  { key: 'Friday', title: 'الجمعة' },
  { key: 'Saturday', title: 'السبت' },
]

export const reqCounts = Vue.observable({ leave: 0, visit: 0, loaded: false, tick: 0 })

function user() {
  try {
    return JSON.parse(localStorage.getItem('user') || 'null')
  } catch (e) {
    return null
  }
}

export function canRequests(type) {
  var ck = window.checkPer
  if (!ck) return false
  return type ? ck(REQ_PERS[type]) : (ck(REQ_PERS.leave) || ck(REQ_PERS.visit))
}

export function pick(r, key) {
  if (!r || typeof r != 'object') return undefined
  if (r[key] !== undefined) return r[key]
  if (r.response && typeof r.response == 'object' && !Array.isArray(r.response)) return r.response[key]
  return undefined
}

// the server's error text (Arabic) or a general one
export function errorText(r) {
  if (r && typeof r.response == 'string' && r.response) return r.response
  if (r && typeof r.message == 'string' && r.message) return r.message
  return 'حدث خطأ، حاول مرة أخرى'
}

export function reqPost(path, body, opts) {
  var u = user()
  var $ = window.$
  return new Promise(function (resolve, reject) {
    $.ajax(Object.assign({
      url: window.api + '/user/students/requests' + path,
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(Object.assign({ jwt: u && u.jwt }, body || {})),
      dataType: 'json',
      timeout: 30000,
    }, opts || {})).done(resolve).fail(function (x) {
      reject(x)
    })
  })
}

// Deep merge of the stored settings over the defaults (unknown keys kept)
export function withDefaults(s) {
  var out = JSON.parse(JSON.stringify(REQ_DEFAULTS))
  if (!s || typeof s != 'object') return out
  ;['leave', 'visit'].forEach(function (t) {
    var x = s[t]
    if (!x || typeof x != 'object') return
    Object.keys(x).forEach(function (k) {
      if (k == 'approve_defaults' && x[k] && typeof x[k] == 'object') {
        out[t].approve_defaults = Object.assign({}, out[t].approve_defaults, x[k])
      } else if (x[k] !== undefined && x[k] !== null) {
        out[t][k] = x[k]
      }
    })
  })
  Object.keys(s).forEach(function (k) {
    if (k != 'leave' && k != 'visit') out[k] = s[k]
  })
  return out
}

// the settings object in a /settings reply: {response: {leave, visit}} | {settings: …} | {response: {settings: …}}
export function settingsOf(r) {
  var c = [pick(r, 'settings'), r && r.response, r]
  for (var i = 0; i < c.length; i++) {
    if (c[i] && typeof c[i] == 'object' && (c[i].leave || c[i].visit)) return c[i]
  }
  return null
}

// ---------------------------------------------------------------- badges + toast

var started = false
var timer = null
var unsupported = false

function num(x) {
  var n = parseInt(x, 10)
  return isNaN(n) || n < 0 ? 0 : n
}

var listeners = []
export function onRequestsRise(fn) {
  listeners.push(fn)
  return function () {
    listeners = listeners.filter(function (f) { return f !== fn })
  }
}

export function refreshRequestCounts() {
  if (unsupported || !canRequests() || !window.$ || !window.api) return Promise.resolve(reqCounts)
  return reqPost('/counts', {}, { global: false, timeout: 15000 }).then(function (r) {
    if (!r || r.status != 100) return reqCounts
    var leave = canRequests('leave') ? num(pick(r, 'leave_pending')) : 0
    var visit = canRequests('visit') ? num(pick(r, 'visit_pending')) : 0
    var rose = []
    if (reqCounts.loaded) {
      if (leave > reqCounts.leave) rose.push({ type: 'leave', n: leave, added: leave - reqCounts.leave })
      if (visit > reqCounts.visit) rose.push({ type: 'visit', n: visit, added: visit - reqCounts.visit })
    }
    reqCounts.leave = leave
    reqCounts.visit = visit
    reqCounts.loaded = true
    if (rose.length) {
      reqCounts.tick++
      listeners.forEach(function (f) {
        try { f(rose) } catch (e) {}
      })
    }
    return reqCounts
  }).catch(function (x) {
    // 404 = the server has no requests routes yet
    if (x && x.status == 404) {
      unsupported = true
      if (timer) clearInterval(timer)
    }
    return reqCounts
  })
}

function bell() {
  try {
    var a = new Audio('/assets/sounds/bell.mp3')
    var p = a.play()
    if (p && p.catch) p.catch(function () {})
  } catch (e) {}
}

// One poll for the whole dashboard; the toast is shown from `vm` (any mounted component).
export function startRequestCounts(vm) {
  if (started || !canRequests()) return
  var u = user()
  if (!u || !u.jwt) return
  started = true
  onRequestsRise(function (rose) {
    rose.forEach(function (x) {
      var title = x.type == 'leave' ? 'طلب استئذان جديد' : 'طلب زيارة جديد'
      var text = x.type == 'leave'
        ? 'لديك ' + x.n + ' ' + (x.n == 1 ? 'طلب استئذان' : 'طلبات استئذان') + ' بانتظار الإجراء. اضغط للعرض.'
        : 'لديك ' + x.n + ' ' + (x.n == 1 ? 'طلب زيارة' : 'طلبات زيارة') + ' بانتظار الإجراء. اضغط للعرض.'
      showToast(vm, x.type, title, text)
    })
    bell()
  })
  refreshRequestCounts()
  timer = setInterval(function () {
    if (document.hidden) return
    refreshRequestCounts()
  }, 60 * 1000)
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) refreshRequestCounts()
  })
}

function go(vm, type) {
  var path = REQ_PAGES[type]
  // the sidebar is built for the system in the address (/_students…): another system needs a full load
  if (window.location.pathname.indexOf('/_students') === 0 && vm && vm.$router) {
    if (window.location.pathname != path) vm.$router.push(path).catch(function () {})
  } else {
    window.location.href = path
  }
}

function showToast(vm, type, title, text) {
  if (!vm || !vm.$toast) return
  var h = vm.$createElement
  var content = h('div', { class: 'prq-toast', attrs: { dir: 'rtl' } }, [
    h('div', { class: 'prq-toast-ic ' + type }, [h('i', { class: 'fa ' + (type == 'leave' ? 'fa-sign-out' : 'fa-calendar-check-o') })]),
    h('div', { class: 'prq-toast-txt' }, [h('b', title), h('small', text)]),
  ])
  vm.$toast(content, {
    timeout: 10000,
    closeOnClick: true,
    toastClassName: 'prq-toast-wrap',
    onClick: function () { go(vm, type) },
  })
}
